import React, { createRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useSnackbar } from 'notistack'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { TabContext } from '@mui/lab'
import { Tabs, Tab, Tooltip } from '@mui/material'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../utils'
import {
  // -- actions: VARIABLES
  // createProjectVariable,
  // updateProjectVariable,
  // deleteProjectVariable,
  // searchProjectVariables,
  // -- actions: RESOURCES
  // createProjectResource,
  // updateProjectResource,
  // deleteProjectResource,
  // searchProjectResources,
  // -- actions: PRODUCTS
  // createProjectProduct,
  // updateProjectProduct,
  // deleteProjectProduct,
  // searchProjectProducts,
  // -- actions: LOCATIONS
  createProjectLocation,
  updateProjectLocation,
  deleteProjectLocation,
  searchProjectLocations,
  // -- actions: WEATHERS
  // createProjectWeather,
  // updateProjectWeather,
  deleteProjectWeather,
  searchProjectWeathers,
  // -- actions: PARAMETERS
  // createProjectParameter,
  // updateProjectParameter,
  // deleteProjectParameter,
  // searchProjectParameters,
  // -- actions: IMPORT
  importProjectGlobals
} from '../../../actions'
import {
  iconNames,
  Icon,
  AttributesTabPanel,
  // AttributeResourcePanel,
  // AttributeProductPanel,
  // AttributeVariablePanel,
  AttributeLocationPanel,
  // AttributeParameterPanel,
  AttributeWeatherPanel,
  AccessControl,
  AccessControlNoRights
} from '../../../components'
import { GlobalAttributeTabsDialog } from '../../globalAttributes'
import './style.scss'
import { attributesNames, userRightTypes } from '../../../constants'

export const ProjectAttributesTabs = ({
  currentProject,
  currentScenario,
  loadData,
  variables,
  resources,
  products,
  locations,
  weather_data,
  parameters
}) => {
  const { t } = useTranslation()
  const ref = createRef()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const [tabValue, setTabValue] = useState(0)

  // -- Dialog
  const [openDialogLocation, setOpenDialogLocation] = useState(false)
  const [openDialogWeather, setOpenDialogWeather] = useState(false)
  // const [openDialogVariable, setOpenDialogVariable] = useState(false)
  // const [openDialogResource, setOpenDialogResource] = useState(false)
  // const [openDialogProduct, setOpenDialogProduct] = useState(false)
  // const [openDialogParameter, setOpenDialogParameter] = useState(false)

  // -- Search
  const [searchTermLocations, setSearchTermLocations] = useState('')
  const [searchTermWeathers, setSearchTermWeathers] = useState('')
  // const [searchTermVariables, setSearchTermVariables] = useState('')
  // const [searchTermResources, setSearchTermResources] = useState('')
  // const [searchTermProducts, setSearchTermProducts] = useState('')
  // const [searchTermParameters, setSearchTermParameters] = useState('')

  const [openImportDialog, setOpenImportDialog] = useState(false)

  const onTabChange = (event, newValue) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onTabChange()', { event, newValue })
    setTabValue(newValue)
  }

  const _dispatchAction = ({ func, funcName }) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs._dispatchAction()', { funcName })

    dispatch(func)
      .then((res) => {
        Logger.trace(LoggerTypes.CONTROLLER, `ProjectAttributesTabs._dispatchAction().dispatch(${funcName}).then()`, {
          res
        })
        if (res?.data?.isAxiosError) {
          enqueueSnackbar(t('common.api_failure'), { variant: 'error' })
        }
      })
      .catch((res) => {
        Logger.trace(LoggerTypes.WARN, `ProjectAttributesTabs._dispatchAction().dispatch(${funcName}).catch()`, { res })

        checkErrorResponse(res, enqueueSnackbar, t)
      })
  }

  // == RESOURCES
  // const onProjectResourceDelete = (resourceId, _projectId) => {
  //   Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onProjectResourceDelete()', {
  //     _projectId,
  //     resourceId
  //   })
  //   _dispatchAction({ func: deleteProjectResource(resourceId, _projectId), funcName: 'deleteProjectResource' })
  // }
  // const onProjectResourceCreate = () => {
  //   Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onProjectResourceCreate()')
  //   setOpenDialogResource(true)
  // }
  // const onProjectResourceSearch = (term) => {
  //   setSearchTermResources(term.target.value)
  //   dispatch(searchProjectResources(term.target.value))
  // }

  // == PRODUCTS
  // const onProjectProductDelete = (productId, _projectId) => {
  //   Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onProjectProductDelete()', {
  //     _projectId,
  //     productId
  //   })
  //   _dispatchAction({ func: deleteProjectProduct(productId, _projectId), funcName: 'deleteProjectProduct' })
  // }
  // const onProjectProductCreate = () => {
  //   Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onProjectProductCreate()')
  //   setOpenDialogProduct(!openDialogProduct)
  // }
  // const onProjectProductSearch = (term) => {
  //   setSearchTermProducts(term.target.value)
  //   dispatch(searchProjectProducts(term.target.value))
  // }

  // == VARIABLES
  // const onProjectVariableDelete = (variableId, _projectId) => {
  //   Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onDeleteProjectVariable()', {
  //     _projectId,
  //     variableId
  //   })
  //   _dispatchAction({ func: deleteProjectVariable(variableId, _projectId), funcName: 'deleteProjectVariable' })
  // }
  // const onProjectVariableCreate = () => {
  //   Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onVariablesDialogOpen()')
  //   setOpenDialogVariable(true)
  // }
  // const onProjectVariableSearch = (term) => {
  //   setSearchTermVariables(term.target.value)
  //   dispatch(searchProjectVariables(term.target.value))
  // }

  // == LOCATIONS
  const onProjectLocationDelete = (locationId, _projectId) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onProjectLocationDelete()', {
      _projectId,
      locationId
    })
    _dispatchAction({ func: deleteProjectLocation(locationId, _projectId), funcName: 'deleteProjectLocation' })
  }
  const onProjectLocationCreate = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onProjectLocationCreate()')
    setOpenDialogLocation(!openDialogLocation)
  }
  const onProjectLocationSearch = (term) => {
    setSearchTermLocations(term.target.value)
    dispatch(searchProjectLocations(term.target.value))
  }

  // == WEATHERS
  const onProjectWeatherDelete = (weatherId, _projectId) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onProjectWeatherDelete()', {
      _projectId,
      weatherId
    })
    _dispatchAction({ func: deleteProjectWeather(weatherId, _projectId), funcName: 'deleteProjectWeather' })
  }
  // const onProjectWeatherCreate = () => {
  //   Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onProjectWeatherCreate()')
  //   setOpenDialogWeather(!openDialogWeather)
  // }
  const onProjectWeatherSearch = (term) => {
    setSearchTermWeathers(term.target.value)
    dispatch(searchProjectWeathers(term.target.value))
  }

  // == PARAMETERS
  // const onProjectParameterDelete = (parameterId, _projectId) => {
  //   Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onProjectParameterDelete()', {
  //     _projectId,
  //     parameterId
  //   })
  //   _dispatchAction({ func: deleteProjectParameter(parameterId, _projectId), funcName: 'deleteProjectParameter' })
  // }
  // const onProjectParameterCreate = () => {
  //   Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onProjectParameterCreate()')
  //   setOpenDialogParameter(!openDialogParameter)
  // }
  // const onProjectParameterSearch = (term) => {
  //   setSearchTermParameters(term.target.value)
  //   dispatch(searchProjectParameters(term.target.value))
  // }

  // == IMPORT
  const onProjectAttributeImportOpen = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ProjectAttributesTabs.onProjectAttributeImportOpen()', { openImportDialog })
    setOpenImportDialog(true)
  }

  Logger.trace(LoggerTypes.CONTAINER, 'ProjectAttributesTabs.render()', {
    currentProject,
    currentScenario,
    loadData,
    attributes: {
      variables,
      resources,
      products,
      locations,
      weather_data,
      parameters
    }
  })

  return (
    <div className="ProjectAttributesTabs">
      <AccessControl
        userPermissions={[userRightTypes.PROJECT_ATTRIBUTES_READ]}
        renderNoAccess={() => <AccessControlNoRights />}
      >
        <TabContext value={`${tabValue}`}>
          <Tabs aria-label="library selector" centered={true} value={tabValue} onChange={onTabChange}>
            <Tooltip ref={ref} title={t('attributes.weather_data.tab_title')}>
              <Tab
                disableRipple={true}
                id={`simple-tab-${0}`}
                icon={<Icon name={iconNames.WEATHER_DATA} size={22} />}
              />
            </Tooltip>
            <Tooltip ref={ref} title={t('attributes.locations.tab_title')}>
              <Tab disableRipple={true} id={`simple-tab-${1}`} icon={<Icon name={iconNames.LOCATION} size={18} />} />
            </Tooltip>
            {/* <Tooltip ref={ref} title={t('attributes.resources.tab_title')}> */}
            {/* <Tab disabled disableRipple={true} id={`simple-tab-${2}`} icon={<Icon name={iconNames.RESOURCE} size={20} />} /> */}
            {/* </Tooltip> */}
            {/* <Tooltip ref={ref} title={t('attributes.products.tab_title')}> */}
            {/* <Tab disabled disableRipple={true} id={`simple-tab-${3}`} icon={<Icon name={iconNames.PRODUCT} size={20} />} /> */}
            {/* </Tooltip> */}
            {/* <Tooltip ref={ref} title={t('attributes.variables.tab_title')}> */}
            {/* <Tab disabled disableRipple={true} id={`simple-tab-${4}`} icon={<Icon name={iconNames.VARIABLE} size={20} />} /> */}
            {/* </Tooltip> */}
            {/* <Tooltip ref={ref} title={t('attributes.parameters.tab_title')}> */}
            {/* <Tab disabled disableRipple={true} id={`simple-tab-${5}`} icon={<Icon name={iconNames.PARAMETER} size={18} />} /> */}
            {/* </Tooltip> */}
          </Tabs>

          {/* TAB - WEATHERS */}
          <AttributesTabPanel value={tabValue} index={0}>
            <AttributeWeatherPanel
              currentProject={currentProject}
              currentScenario={currentScenario}
              weather_data={weather_data}
              terms={searchTermWeathers}
              openDialog={openDialogWeather}
              setOpenDialog={setOpenDialogWeather}
              onSearch={onProjectWeatherSearch}
              onDelete={onProjectWeatherDelete}
              onImport={onProjectAttributeImportOpen}
              // onAdd={onProjectWeatherCreate}
              // onCreate={createProjectWeather}
              // onUpdate={updateProjectWeather}
            />
          </AttributesTabPanel>

          {/* TAB - LOCATIONS */}
          <AttributesTabPanel value={tabValue} index={1}>
            <AttributeLocationPanel
              currentProject={currentProject}
              currentScenario={currentScenario}
              locations={locations}
              terms={searchTermLocations}
              openDialog={openDialogLocation}
              setOpenDialog={setOpenDialogLocation}
              onSearch={onProjectLocationSearch}
              onAdd={onProjectLocationCreate}
              onDelete={onProjectLocationDelete}
              onCreate={createProjectLocation}
              onUpdate={updateProjectLocation}
              // onImport={onProjectAttributeImportOpen}
            />
          </AttributesTabPanel>

          {
            // TAB - RESOURCES
            /*
          <AttributesTabPanel value={tabValue} index={2}>
            <AttributeResourcePanel
              currentProject={currentProject}
              currentScenario={currentScenario}
              resources={resources}
              terms={searchTermResources}
              openDialog={openDialogResource}
              setOpenDialog={setOpenDialogResource}
              onSearch={onProjectResourceSearch}
              onAdd={onProjectResourceCreate}
              onDelete={onProjectResourceDelete}
              onCreate={createProjectResource}
              onUpdate={updateProjectResource}
              onImport={onProjectAttributeImportOpen}
            />
          </AttributesTabPanel> */
          }

          {/* TAB - PRODUCTS */}
          {/* <AttributesTabPanel value={tabValue} index={3}>
          <AttributeProductPanel
            currentProject={currentProject}
            currentScenario={currentScenario}
            products={products}
            terms={searchTermProducts}
            openDialog={openDialogProduct}
            setOpenDialog={setOpenDialogProduct}
            onSearch={onProjectProductSearch}
            onAdd={onProjectProductCreate}
            onDelete={onProjectProductDelete}
            onCreate={createProjectProduct}
            onUpdate={updateProjectProduct}
            onImport={onProjectAttributeImportOpen}
          />
        </AttributesTabPanel> */}

          {/* TAB - VARIABLES */}
          {/* <AttributesTabPanel value={tabValue} index={4}>
          <AttributeVariablePanel
            currentProject={currentProject}
            currentScenario={currentScenario}
            variables={variables}
            terms={searchTermVariables}
            openDialog={openDialogVariable}
            setOpenDialog={setOpenDialogVariable}
            onSearch={onProjectVariableSearch}
            onAdd={onProjectVariableCreate}
            onDelete={onProjectVariableDelete}
            onCreate={createProjectVariable}
            onUpdate={updateProjectVariable}
            onImport={onProjectAttributeImportOpen}
          />
        </AttributesTabPanel> */}

          {/* TAB - PARAMETERS */}
          {/* <AttributesTabPanel value={tabValue} index={5}>
          <AttributeParameterPanel
            currentProject={currentProject}
            currentScenario={currentScenario}
            parameters={parameters}
            terms={searchTermParameters}
            openDialog={openDialogParameter}
            setOpenDialog={setOpenDialogParameter}
            onSearch={onProjectParameterSearch}
            onAdd={onProjectParameterCreate}
            onDelete={onProjectParameterDelete}
            onCreate={createProjectParameter}
            onUpdate={updateProjectParameter}
            onImport={onProjectAttributeImportOpen}
          />
        </AttributesTabPanel> */}

          {openImportDialog && (
            <GlobalAttributeTabsDialog
              currentProject={currentProject}
              currentScenario={currentScenario}
              tabValue={tabValue}
              // -- MUST respect the tabs order
              tabIdentifier={[
                attributesNames.WEATHER_DATA, // 0
                attributesNames.LOCATIONS, // 1
                attributesNames.RESOURCES, // 2
                attributesNames.PRODUCTS, // 3
                attributesNames.VARIABLES, // 4
                attributesNames.PARAMETERS // 5
              ]}
              setTabValue={setTabValue}
              openDialog={openImportDialog}
              setOpenDialog={setOpenImportDialog}
              actionDispatchImport={importProjectGlobals}
              // -- MUST respect the order of appearance in the Global import popin
              tabVisible={{
                weather_data: true,
                locations: false,
                resources: false,
                products: false,
                variables: false,
                parameters: false
              }}
              // -- object of array of objects that contain the selected items in the
              // -- Global import attribute popin
              selectedAttributes={{
                weather_data,
                locations,
                resources,
                products,
                variables,
                parameters
              }}
              loadData={loadData}
            />
          )}
        </TabContext>
      </AccessControl>
    </div>
  )
}

ProjectAttributesTabs.displayName = 'ProjectAttributesTabs'

ProjectAttributesTabs.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  loadData: PropTypes.arrayOf(PropTypes.object).isRequired,
  variables: PropTypes.array.isRequired,
  resources: PropTypes.array.isRequired,
  products: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired,
  weather_data: PropTypes.array.isRequired,
  parameters: PropTypes.array.isRequired
}

ProjectAttributesTabs.defaultProps = {
  currentProject: null,
  currentScenario: null,
  loadData: [],
  variables: [],
  resources: [],
  products: [],
  locations: [],
  weather_data: [],
  parameters: []
}
